// extracted by mini-css-extract-plugin
export default {"wrapper":"Ge0xr","gallery":"ZnFBm","slide":"T5DOy"};